// frontend/src/api/fetchWithAuth.ts
import type { GetTokenSilentlyOptions } from '@auth0/auth0-react';

export async function fetchWithAuth(
  getAccessTokenSilently: (options?: GetTokenSilentlyOptions) => Promise<string>,
  input: RequestInfo | URL,
  init: RequestInit = {}
) {
  const token = await getAccessTokenSilently({
    authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
  });

  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);

  // Only set Content-Type automatically when sending a body
  if (init.body && !headers.get('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(input, {
    ...init,
    headers,
    credentials: init.credentials ?? 'include',
  });
}
